import { isEmpty } from './helpers/is-empty';
import { ValidatorFunction } from '../types/validator-function.type';

const defaultError: Record<string, boolean> = { required: true } as const;

export const required: ValidatorFunction = (value: any) => {
  let errors = null;

  if (isEmpty(value)) {
    errors = defaultError;
  }

  return errors;
};
